import axios from "axios";

//to change
// export const BASE_URL = 'http://localhost:5001/api/';



export const BASE_URL = 'https://api.prodinent.com/api/';  

// Public request instance (no authentication required)
export const publicRequest = axios.create({
    baseURL: BASE_URL,
    withCredentials: true, 
});

// Add request interceptor for logging
publicRequest.interceptors.request.use(
  (config) => {
    //   method: config.method?.toUpperCase(),
    //   url: config.url,
    //   baseURL: config.baseURL,
    //   fullURL: `${config.baseURL}${config.url}`,
    //   headers: config.headers
    // });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for logging
publicRequest.interceptors.response.use(
  (response) => {
    //   status: response.status,
    //   statusText: response.statusText,
    //   url: response.config.url,
    //   data: response.data
    // });
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
